import { MutationTree } from 'vuex';
import { TrainerPaymentState } from './types';
import trainerPayment, { TrainerPayment, Value } from '@/shared/model/trainerPayment';

export const mutations: MutationTree<TrainerPaymentState> = {
  setTrainerPayments(state, payload: Value) {
    state.trainerPayments.items = payload.value.map((x) => trainerPayment.parse(x));
    state.trainerPayments.total = payload['@odata.count'] || 0;
    state.trainerPayments.isLoading = false;
  },
  setTrainerPaymentsTotal(state, payload: number) {
    state.trainerPayments.total = payload;
  },
  setTrainerPaymentsIsLoading(state, payload: boolean) {
    state.trainerPayments.isLoading = payload;
  },
  resetTrainerPaymentsPaging(state) {
    state.trainerPayments.searchParams.dataOption.page = 1;
    state.trainerPayments.searchParams.dataOption.itemsPerPage = 10;
    state.trainerPayments.searchParams.dataOption.filter = '';
    state.trainerPayments.searchParams.filter = '';
  },
};
